import styled from '@emotion/styled';
import React from 'react';

import { useComponentTheme } from '../useComponentTheme';
import { withSpacingStyles } from '../withSpacingStyles';

type Props = {
  className?: string,
  mode?: string,
  width: string,
};

export const Separator = withSpacingStyles(({ className, mode, width = '100%' }: Props) => {
  const componentTheme = useComponentTheme(theme => theme.components.Separator, mode);

  return (
    <Line
      aria-hidden="true"
      className={className}
      componentTheme={componentTheme}
      data-test="separator"
      width={width}
    />
  );
});

Separator.displayName = 'Separator';

const Line = styled.hr<{ componentTheme: Record<string, string>, width: string }>(
  ({ componentTheme, width }) => `
    margin-top: 0;
    margin-bottom: 16px;
    background-color: ${componentTheme.backgroundColor};
    border: none;
    width: ${width};
    height: 1px;
  `
);
